<template>
  <span v-if="props.anchor" :id="props.anchor" class="anchor"></span>
  <div class="card" v-bind="$attrs">
    <h4 class="card-header text-uppercase bg-primary">Couts</h4>
    <div class="card-body">
      <div class="row d-flex justify-content-between">
        <div class="col-12 col-sm-9 text-success align-self-center mb-2">
          Coût du package : {{ packageCost }} € {{ travel.priceTTC ? 'TTC' : 'HT' }}
          <small class="ms-3 text-muted text-nowrap fst-italic"><br>Coût Némo + (Hébergement x Nbr de nuit) + Remise Sans Vol</small>
        </div>
        <div class="col-12 col-sm-3 mb-3 text-end text-nowrap">
          <ToggleCheckboxComponent
            value-key="priceTTC"
            label-true="Prix TTC"
            label-false="Prix HT"
            title="(Cette option sera appliquée à tous les prix)"
            button-class="btn-outline-success"
          />
        </div>
      </div>
      <div class="mb-3">
        <CheckboxComponent
            value-key="packageMandatory"
            label="Le package est obligatoire (le participant ne pourra pas choisir ses propres dates)"
            :required="true"
            class="mb-3"
          />
      </div>

      <div class="row">
        <div class="col-12 col-lg-4">
          <NumberInputComponent
            value-key="nemoCost"
            label="Coût Nemo"
            placeholder="Coût Nemo"
            :required="true"
            type="euro"
            class="mb-3"
          />
        </div>
        <div class="col-12 col-lg-4">
          <NumberInputComponent
            value-key="accommodationCost"
            label="Coût de l'hébergement"
            placeholder="Coût de l'hébergement"
            :required="true"
            type="euro"
            class="mb-3"
            :group-text="'/ nuit / pers<br>soit ' + (travel.accommodationCost || 0) * (travel.nights || 0) + '€ pour ' + (travel.nights || 0) + ' nuits'"
          />
        </div>
        <div class="col-12 col-lg-4">
          <NumberInputComponent
            value-key="transportCost"
            label="Remise Sans Vol"
            placeholder="Remise Sans Vol"
            :required="true"
            type="euro"
            class="mb-3"
          />
        </div>
        <div class="col-12 col-lg-4">
          <NumberInputComponent
            value-key="childPackageCost"
            label="Coût Nemo Enfant (Optionnel)"
            placeholder="Coût Nemo pour les enfants (Optionnel, laisser vide si non applicable)"
            type="euro"
            class="mb-3"
            group-text="/ enfant"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, onMounted } from 'vue';
import * as zod from 'zod';

const travel = defineModel<AdminTravel>({ required: true });
const validationSchema = defineModel<{ shape: zod.ZodRawShape, anchors?: Record<string, string | undefined> }>('validation-schema',{ required: false, default: () => ({ shape: {} }) });

const props = defineProps<{
  anchor?: string
}>();

const packageCost = computed(() => {
  return (
    Number(travel.value.nemoCost||0) +
    ((travel.value.accommodationCost||0) * (travel.value.nights||0)) +
    Number(travel.value.transportCost||0) || 0
  );
});

onMounted(() => {
  validationSchema.value = {
    shape:{
      nemoCost: zod
        .number({ message: 'Coût Nemo non valide' })
        .nonnegative({ message: 'Le coût Nemo doit être positif' }),
      accommodationCost: zod
        .number({ message: 'Coût de l\'hébergement non valide' })
        .nonnegative({ message: 'Le coût de l\'hébergement doit être positif' }),
      transportCost: zod
        .number({ message: 'Remise sans Vol non valide' })
        .nonnegative({ message: 'La Remise sans Vol doit être positive' }),
      childPackageCost: zod
        .number({ message: 'Coût du package enfant non valide' })
        .nonnegative({ message: 'Le coût du package enfant doit être positif' })
        .nullable()
        .optional(),
      priceTTC: zod.boolean({required_error: "Le choix entre HT et TTC est requis",}),
      packageMandatory: zod.boolean({ message: 'Le choix package obligatoire/facultatif est requis' })
    },
    anchors: {
      "nemoCost": props.anchor,
      "accommodationCost": props.anchor,
      "transportCost": props.anchor,
      "childPackageCost": props.anchor,
      "priceTTC": props.anchor,
      "packageMandatory": props.anchor
    }
  }
});
</script>
